import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store'

const imageLibrarySlice = createSlice({
    name: 'image-library',
    initialState: {
        show: false,
        imageField: '',
        imageUrl: ''
    },
    reducers: {
        showImageLibrary: (state, { payload }: PayloadAction<string>) => {
            state.show = true
            state.imageField = payload
            state.imageUrl = ''
        },
        setCurrentSelectedImage: (state, { payload }: PayloadAction<string>) => {
            state.imageUrl = payload
        },
        closeImageLibrary: (state) => {
            state.show = false
        },
        clearState: (state) => {
            state.imageField = ''
            state.imageUrl = ''
        },
        setCurrentField: (state, { payload }: PayloadAction<string>) => {
            state.imageField = payload
        },
    },
})

export const showImageLibrarySelector = (state: RootState) => state.imageLibrary.show
export const currentSelectedImageSelector = (state: RootState) => state.imageLibrary.imageUrl
export const currentImageFieldSelector = (state: RootState) => state.imageLibrary.imageField

export const {
    showImageLibrary,
    setCurrentSelectedImage,
    closeImageLibrary,
    clearState,
    setCurrentField,
} = imageLibrarySlice.actions

export default imageLibrarySlice.reducer
